import {createSlice} from '@reduxjs/toolkit';

const slice = createSlice({
    name: "app",
    initialState: {
        time: null,
        administrative: []
    },
    reducers: {
        //actions => action handlers
        ADMINISTRATIVE: (state, action) => {
            return {
                ...state,
                administrative: action.payload.administrative
            }
        },
        TIME: (state, action) => {
            return {
                ...state,
                time: action.payload.time
            }
        },
    }
});

export const {ADMINISTRATIVE, TIME} = slice.actions;
export default slice.reducer;
